import { render, staticRenderFns } from "./SaveBar.vue?vue&type=template&id=46119ecc&scoped=true&"
import script from "./SaveBar.vue?vue&type=script&lang=js&"
export * from "./SaveBar.vue?vue&type=script&lang=js&"
import style0 from "./SaveBar.vue?vue&type=style&index=0&id=46119ecc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46119ecc",
  null
  
)

export default component.exports